<template>
  <el-dialog
    :visible="payConfirm"
    width="50%"
    class="payConfirm"
    @close="closePay"
    :close-on-click-modal="false"
  >
    <p class="logoCon">
      <img class="logo" src="../assets/image/logo.png" alt="" />
    </p>
    <el-divider></el-divider>
    <div class="pay">
      <div class="payInfo float-l">
        <el-form label-position="right" label-width="120px" :model="orderInfo">
          <el-form-item :label="$t('pleaseConfirm')"> </el-form-item>
          <el-form-item :label="$t('game') + ':'">
            {{ orderInfo.gameName }}
          </el-form-item>
          <el-form-item :label="$t('server') + ':'">
            {{ orderInfo.serverName }}
          </el-form-item>
          <el-form-item :label="$t('roleName') + ':'">
            {{ orderInfo.roleName }}
          </el-form-item>
          <el-form-item :label="$t('roleId') + ':'">
            {{ orderInfo.roleId }}
          </el-form-item>
          <el-form-item :label="$t('goodsName') + ':'">
            {{ orderInfo.goodsName }}
          </el-form-item>
          <el-form-item :label="$t('price') + ':'">
            {{ orderInfo.realAmount }}
          </el-form-item>
        </el-form>
      </div>
      <div class="payType float-l">
        <p class="payTypeTit">{{ $t("payType") }}:</p>
        <ul class="payTypeList">
          <li v-for="(item, index) in payTypeList" :key="index">
            <a
              href="javascript:;"
              @click="choosePayType(index, item.type)"
              :class="{
                tagActivity: ratingTageIndex == index,
              }"
            >
              <img :src="item.url" alt="" />
            </a>
          </li>
          <div style="clear: both"></div>
        </ul>
        <el-button
          v-if="payCode == 0"
          :loading="payLoading"
          type="danger"
          class="payBtn"
          @click="payDo"
          >{{ $t("immediatePay") }}</el-button
        >
        <el-button v-if="payLoading" @click="cancelPay">{{
          $t("cancel")
        }}</el-button>
        <span class="paySuccess" v-if="payCode > 0">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-check"
            circle
          ></el-button>
          支付成功
        </span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import {
  payAdvance,
  payDo,
  getRealAmount,
  getOrderState,
} from "@/api/recharge";
export default {
  computed: {
    ...mapGetters(["payConfirm", "payOrderId"]),
  },
  data() {
    return {
      payData: null,
      payCode: 0, //未支付1支付成功
      payLoading: false,
      payType: "",
      dialogVisible: true,
      ratingTageIndex: null,
      orderInfo: {},
      payTypeList: [
        // { url: require("../assets/image/payType/paypal.png"), type: 12 },
        // { url: require("../assets/image/payType/mycard.png"), type: 11 },
        // { url: require("../assets/image/payType/googlepay.png"), type: 13 },
        // // { url: require("../assets/image/payType/bank-transfer.png"), type: 14 },
        // { url: require("../assets/image/payType/gold.png"), type: 14 },
      ],
    };
  },
  mounted() {
    this.getOrderInfo();
  },
  methods: {
    goLoop(winObj) {
      var loop = setInterval(() => {
        this.refreshOrder();
        if (this.payCode > 0) {
          this.payLoading = false;
          clearInterval(loop);
        }
        if (winObj.closed) {
          this.payData = JSON.parse(localStorage.getItem("payData"));
          if (this.payData) {
            if (this.payData.code == 1) {
              this.$message({
                message: this.payData.msg,
                type: "error",
                duration: 6000,
                showClose: true,
              });
            }
          } else {
            this.refreshOrder();
          }
          localStorage.removeItem("payData");
          this.payLoading = false;
          clearInterval(loop);
        }
      }, 2000);
    },
    getOrderInfo() {
      payAdvance({ orderId: this.payOrderId }).then((res) => {
        this.orderInfo = res;
      });
    },
    closePay() {
      this.$store.dispatch("payConfirmPage", { type: false });
    },
    choosePayType(index, type) {
      this.ratingTageIndex = index;
      this.payType = type;
      getRealAmount({ orderId: this.payOrderId, payChannelId: type }).then(
        (res) => {
          this.orderInfo.realAmount = res;
        }
      );
    },
    payDo() {
      if (this.payType) {
        this.payLoading = true;
        payDo({ orderId: this.payOrderId, payChannelId: this.payType })
          .then((res) => {
            var winObj = window.open(res.url);
            this.goLoop(winObj);
          })
          .catch((error) => {
            this.payLoading = false;
          });
      } else {
        this.$message.error(this.$i18n.t("choosePayType"));
      }
    },
    refreshOrder() {
      getOrderState({ orderId: this.payOrderId }).then((res) => {
        this.payCode = res;
      });
    },
    // // 取消
    cancelPay() {
      this.payCode = 0;
      this.payLoading = false;
    },
  },
};
</script>
<style lang="scss">
.payConfirm {
  .logoCon {
    text-align: center;
  }
  .payInfo {
    width: 360px;
    .el-form-item {
      margin-bottom: 0px;
    }
  }
  .logo {
    height: 100px;
    width: 100px;
  }
  .pay {
    height: 400px;
    .payType {
      .payBtn {
        margin-left: 140px;
        margin-right: 40px;
      }
      .paySuccess {
        font-size: 16px;
        margin-left: 140px;
      }
      .payError {
        font-size: 16px;
        margin-left: 140px;
      }
      .el-icon-refresh {
        cursor: pointer;
      }
      .payTypeTit {
        line-height: 40px;
      }
      .payTypeList {
        width: 500px;
        .tagActivity {
          border: 2px solid #f68121;
        }
        li {
          height: 100px;
          width: 100px;
          float: left;
          margin: 0 40px 10px 0;
          a {
            display: inline-block;
            width: 96px;
            img {
              width: 100%;
              height: auto;
            }
          }
          a:hover {
            border: 2px solid #f68121;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payConfirm.vue